import axios from 'axios';
import { env } from '../env';

const API_URL = env.apiUrl;

const createController = (endpoint) => {
  const controller = axios.create({
    baseURL: `${API_URL}/${endpoint}`,
    headers: { 
      'Content-Type': 'application/json',
    },
  });

  return controller;
};

export const fetchRegiones = async (endpoint) => {
  try {
    const controller = createController("region");
    const response = await controller.get('');
    return response.data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
};

export const fetchComunas = async(endpoint)=> {
  try{
    const controller = createController("region/comuna?id_region="+endpoint);
    const response = await controller.get('');
    return response.data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
}

export const registerUser = async (data) => {
  try {
    const response = await axios.post(API_URL+'/usuario/', data, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response;
  } catch (error) {
    console.error('Error registering user:', error.response?.data);
      return error;
  }
}

const registerService = {
  fetchRegiones,
  fetchComunas,
  registerUser
};

export default registerService;